module.exports = __webpack_public_path__ + "lg-ecff11700aad0000cf3503f537d1df17.eot";


//////////////////
// WEBPACK FOOTER
// ./~/lightgallery/dist/fonts/lg.eot
// module id = 913
// module chunks = 124